"use strict";

Shopify.theme.jsVideo = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsVideo = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    var $videoElement = $section.find('[data-video-element]');
    var $playButton = $section.find('[data-play-button]');
    var $videoTextContainer = $section.find('[data-video-text-container]');
    var $imageElement = $section.find('[data-image-element]'); // Load video if the media has been added

    if (this.iframe_video || this.html5_video) {
      this.loadVideo($videoElement, $playButton, $videoTextContainer, $imageElement);
    } else {
      $imageElement.show();
    }
    if(this.hide_video_on_mobile && isScreenSizeMedium()){
    	$videoElement.hide()
        $imageElement.show()
    }
    if (this.follow_mouse && isScreenSizeLarge()) {
        let follow = false
        let left = 0
        let top = 0
        $videoTextContainer.on('mouseenter', function(e) {
            follow = true
            $playButton.fadeIn(800).css('border-color','white').css('mix-blend-mode','exclusion')
            window.requestAnimationFrame(follow_Mouse);
        });
        $videoTextContainer.on('mouseleave', function(e) {
            follow = false
            $playButton.fadeOut(300)
            window.cancelAnimationFrame(follow_Mouse);
        });
        $videoTextContainer.on('mousemove', function(e) {
            left = e.pageX - $videoTextContainer.offset().left - $playButton.width()
            top = e.pageY - $videoTextContainer.offset().top - $playButton.height()
        });

        function follow_Mouse() {

            if (follow) {
                if (left < 0) left = 0
                if (top < 0) top = 0
                $playButton.css({
                    left: left + 'px',
                    top: top + 'px'
                })

                window.requestAnimationFrame(follow_Mouse);
            }
        }
        window.requestAnimationFrame(follow_Mouse);
    }
  },
  loadVideo: function loadVideo($videoElement, $playButton, $videoTextContainer, $imageElement) {
    var player = new Plyr(".video-".concat(this.id), {
      controls: videoControls,
      loop: {
        active: this.autoloop
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    player.muted = this.mute;
    player.ratio = this.aspect_ratio; // If autoplay enabled, hide image and text

    if (this.autoplay) {
      player.autoplay = true;
      $imageElement.hide();
      //$videoTextContainer.hide();
      $videoElement.show();
      let isVideoPlaying = setInterval(function(){
        if(!player.playing){
        	player.play()
            clearInterval(isVideoPlaying)
        }
      },300)
    } else {
      // If autoplay disabled, check if poster image added
      if (this.poster) {
        $videoElement.hide();
        $imageElement.show();
        $videoTextContainer.show();
      } else {
        // If autoplay disabled and no poster image
        $imageElement.hide();
        $videoElement.show();
        $videoTextContainer.show();
      }
    } // If button exists, on click show video and hide image/text


    if (this.button) {
      $playButton.on('click', function () {
        player.play();
        console.log(player.fullscreen.active)
        $imageElement.hide();
        $videoTextContainer.hide();
        $videoElement.show();
      });
    } // On player ready, hide play icon if play button visible


    player.on('ready', function (index, player) {
      if ($videoTextContainer && Shopify.theme.jsVideo.button) {
        $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').hide();
      } else {
        $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').show();
      }
    }); // On player pause, show play icon if play button hidden
    player.on('pause', function (index, player) {
      player = index.detail.plyr
      if(!player.autoplay){
        $videoTextContainer.show()
        $imageElement.show();
        $videoElement.hide();
      }else{
        player.play()
        $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').show();      
      }
    }); 
    player.on('exitfullscreen', function (index, player) {
      player = index.detail.plyr
       if(!player.autoplay){
         player.pause()
       }
    }); 
    
    // Clicking anywhere on video should play the video
    if(player.playing){
      $videoElement.on('click', function () {
        player.pause();
        $videoTextContainer.show()
        $videoElement.hide();
        $imageElement.show();
        //$videoTextContainer.hide();
      });
    }
    if (!this.autoplay) {
      $videoTextContainer.on('click', function () {
        player.play();
         if (isScreenSizeMedium()) {
           player.fullscreen.enter();
         }
        $videoTextContainer.hide()
        $videoElement.show();
        $imageElement.hide();
        //$videoTextContainer.hide();
      });
    }
  },
  unload: function unload($section) {
    var $playButton = $section.find('[data-play-button]');
    var $videoTextContainer = $section.find('[data-video-text-container]');
    $playButton.off();
    $videoTextContainer.off();
  }
};



//          if(left>$videoTextContainer.width() - 70){
//             console.log(left,top,$videoTextContainer.width())
//             console.log('out from right')
//             left = $videoTextContainer.width() - 70
//             $playButton.css({
//             left:left+'px',
//             top:top+'px'
//           })
//             follow = false
//           }
//           if(left<0){
//             console.log('out from left')
//             left = 0
//             $playButton.css({
//             left:left+'px',
//             top:top+'px'
//           })
//             follow = false
//           }
//           if(top>$videoTextContainer.height()-70){
//             console.log('out from bottom')
//             top = $videoTextContainer.height() - 70
//             $playButton.css({
//             left:left+'px',
//             top:top+'px'
//           })
//             follow = false
//           }
//           if(top<0){
//             console.log('out from top')
//             top = 0
//             $playButton.css({
//             left:left+'px',
//             top:top+'px'
//           })
//             follow = false
//           }